import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=799452ec&scoped=true&"
import script from "./AppDetail.vue?vue&type=script&lang=js&"
export * from "./AppDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=799452ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799452ec",
  null
  
)

export default component.exports